/* nx-hero-search.js — All Brands 首屏的常驻搜索
 *
 * 为什么不复用 nx-search.js：那个是给 3D 展厅顶栏做的，打开时会**锁死整页滚动**
 * （展厅镜头跟着 scrollY 走，不锁就会乱飞）。放在 hero 里，用户一点搜索框
 * 页面就滚不动了。所以这里重写一个：常驻、不锁滚动、不做开关。
 *
 * 复用的只有一样东西 —— 价格格式化。那是踩过坑的：
 * 不能用 Intl.NumberFormat，它跟着访客浏览器语言走，同一个价格在中文浏览器上
 * 会变成 "US$174.89"，和站内其它地方的 "$174.89" 对不上。必须用店铺自己的
 * money_format，并且先解 HTML 实体（&euro; 之类）再去标签。
 *
 * 走 Shopify 原生 /search/suggest.json，不依赖主题的搜索组件。
 */
(function () {
  var root = document.getElementById("nxh-search");
  if (!root) return;

  var form  = root.querySelector("form");
  var input = root.querySelector("input[name='q']");
  var panel = root.querySelector(".nxh-panel");
  var SEARCH_URL = root.dataset.searchUrl || "/search";
  var LIMIT = 6;

  // 用 textarea 解实体：它的内容是 RCDATA，只认字符实体、不会真的建出元素，
  // 比 innerHTML 到 div 上安全
  var FMT = (function (raw) {
    var ta = document.createElement("textarea");
    ta.innerHTML = raw || "${{amount}}";
    return (ta.value || "${{amount}}").replace(/<[^>]*>/g, "").trim();
  })(root.dataset.moneyFormat);

  function money(v) {
    var n = parseFloat(v);
    if (!isFinite(n)) return "";
    return FMT.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, key) {
      var dec   = key.indexOf("no_decimals") >= 0 ? 0 : 2;
      var thou  = key.indexOf("apostrophe_separator") >= 0 ? "'"
                : key.indexOf("comma_separator") >= 0 ? "." : ",";
      var point = key.indexOf("comma_separator") >= 0 ? "," : ".";
      var parts = n.toFixed(dec).split(".");
      var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts[1] ? int + point + parts[1] : int;
    });
  }
  function thumb(u) { return u ? u + (u.indexOf("?") < 0 ? "?" : "&") + "width=120" : ""; }
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  var timer = null, lastQ = "", ctrl = null;

  function close() { panel.hidden = true; panel.innerHTML = ""; root.classList.remove("has"); }

  function render(items, q) {
    if (!items.length) {
      panel.innerHTML = '<div class="nxh-empty">没有匹配 “' + esc(q) + '” 的商品</div>';
    } else {
      panel.innerHTML = items.map(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : "";
        return '<a class="nxh-hit" href="' + esc(p.url) + '">' +
          (img ? '<img src="' + esc(thumb(img)) + '" alt="" loading="lazy">' : '<span class="nxh-noimg"></span>') +
          '<span class="nxh-t">' + esc(p.title) + '</span>' +
          '<span class="nxh-p">' + esc(money(p.price)) + '</span></a>';
      }).join("") +
      '<a class="nxh-all" href="' + esc(SEARCH_URL) + '?q=' + encodeURIComponent(q) +
      '&type=product">看全部结果 &rarr;</a>';
    }
    panel.hidden = false;
    root.classList.add("has");
  }

  function run(q) {
    if (ctrl) ctrl.abort();
    ctrl = new AbortController();
    var url = SEARCH_URL + "/suggest.json?q=" + encodeURIComponent(q) +
      "&resources[type]=product&resources[limit]=" + LIMIT +
      "&resources[options][unavailable_products]=last";
    fetch(url, { signal: ctrl.signal })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (j) {
        var items = (j.resources && j.resources.results && j.resources.results.products) || [];
        if (input.value.trim() === q) render(items, q);
      })
      .catch(function (e) { if (e && e.name !== "AbortError") close(); });
  }

  input.addEventListener("input", function () {
    var q = input.value.trim();
    if (q === lastQ) return;
    lastQ = q;
    clearTimeout(timer);
    if (q.length < 2) { close(); return; }
    timer = setTimeout(function () { run(q); }, 180);
  });

  input.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { close(); input.blur(); }
  });

  // 点外面收起面板 —— 但不拦截任何滚动
  document.addEventListener("click", function (e) {
    if (!root.contains(e.target)) close();
  });

  form.addEventListener("submit", function () { /* 交给原生 /search 提交 */ });
})();
